// Aurora — gradient avatar bubbles.
//
// The Figma redesign replaces the flat --theme-avatar-N-bg squares
// with violet/cyan/orange/magenta gradient bubbles. Index selection
// stays on the existing avatarPaletteIndex hash (lib/theme.ts) so a
// user keeps the same colour family they had before — only the fill
// goes from flat to gradient.
//
// Exposed as a CSS background value (not a Tailwind class) because the
// index is data-driven per user.

export const AVATAR_GRADIENTS: ReadonlyArray<readonly [string, string]> = [
  ["#8b6cff", "#6366f1"], // violet → indigo
  ["#22c1c3", "#2d9cdb"], // teal → blue
  ["#34d399", "#0ea5a4"], // green → teal
  ["#fb923c", "#f43f5e"], // orange → rose
  ["#f472b6", "#8b6cff"], // pink → violet
  ["#a78bfa", "#6d28d9"], // lavender → deep violet
];

/** CSS `background` value for palette index N (mod-wrapped). */
export function avatarGradientCSS(index: number): string {
  const [a, b] = AVATAR_GRADIENTS[Math.abs(index) % AVATAR_GRADIENTS.length]!;
  return `linear-gradient(135deg, ${a}, ${b})`;
}

/** Gradient keyed by an arbitrary string (workspace/conversation
 *  names — anywhere there's no palette index yet). Same hash as the
 *  Home command center so e.g. a workspace renders the same bubble
 *  on the rail, the Home cards, and the sidebar header. */
export function gradientCSSFor(seed: string): string {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return avatarGradientCSS(h % AVATAR_GRADIENTS.length);
}
